module.exports = __webpack_public_path__ + "img/foto_aplicacoes_empilhadeiras_SMALL.4a1e5115.jpg";